var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 20,
    fill: "#DDDDDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment - 2 Column Design"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1309,
    transform: "translate(-963 -1009)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2610",
    x: -842.5,
    y: -908.5,
    width: 1199,
    height: 1138,
    rx: 9.5,
    fill: "white",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9627 18.2856C28.9627 19.2325 28.1962 20 27.2507 20H1.71202C0.766493 20 0 19.2323 0 18.2856V1.71431C0 0.767493 0.766493 0 1.71202 0H27.2506C28.1962 0 28.9626 0.767549 28.9626 1.71431L28.9627 18.2856Z",
    fill: "#34495E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5038 9.98949C17.5062 9.44369 17.3018 8.8971 16.8905 8.4852C16.4783 8.07245 15.931 7.86798 15.3848 7.87126C15.3822 7.87126 15.3797 7.87109 15.3769 7.87109C14.1908 7.87109 13.25 8.81293 13.25 10.0009C13.25 11.1772 14.2024 12.1306 15.3769 12.1306C16.5634 12.1306 17.5041 11.1886 17.5041 10.0009C17.5041 9.99702 17.5038 9.99334 17.5038 9.98949Z",
    fill: "#F26E21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.857 10.8999C12.5391 11.2186 12.2457 11.3431 11.9297 11.3498C11.1597 11.3429 10.5936 10.772 10.5936 9.95796C10.5936 9.54821 10.7486 9.21239 10.994 8.9255C11.2242 8.70669 11.5207 8.56531 11.8617 8.56531C12.2298 8.56531 12.5163 8.68817 12.8433 9.01584V8.07384C12.5163 7.91009 12.2297 7.82812 11.8617 7.82812C11.3417 7.86534 10.8515 8.07571 10.4754 8.40604C10.367 8.50369 10.2632 8.61148 10.1751 8.73484C9.9004 9.09134 9.73438 9.52788 9.73438 9.99908C9.73438 11.1867 10.6755 12.0877 11.8617 12.0877C11.8674 12.0877 11.8731 12.0872 11.8787 12.0872C11.8867 12.0873 11.8946 12.0877 11.9025 12.0877C12.2297 12.0877 12.5163 12.006 12.8843 11.8421L12.857 10.8999C12.8432 10.9137 12.8707 10.9266 12.857 10.9397V10.8999Z",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.1847 8.41513L19.2584 10.6956L18.1948 7.99219H17.3359L19.0129 12.129H19.4629L21.2218 7.99219H20.3629L20.1847 8.41513Z",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.5547 9.79441V12.0063H23.7637H23.8044V11.3507H23.1091H22.3728V10.6137V10.2452H23.7637V9.54864H22.3728V8.68859H23.8044V7.99219H21.5547V9.79441Z",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.06743 7.99219H1.92188V12.0063H3.06737C3.68085 12.0063 4.13073 11.8423 4.49888 11.5556C4.94876 11.187 5.23522 10.6137 5.23522 9.99945C5.23527 8.81134 4.37612 7.99219 3.06743 7.99219ZM4.00815 11.0233C3.7627 11.228 3.43546 11.3507 2.94456 11.3507H2.69912V8.68854H2.90361C3.3945 8.68854 3.72175 8.77044 3.96725 9.0161C4.25354 9.26169 4.41725 9.63054 4.41725 9.99928C4.45815 10.3679 4.29455 10.7773 4.00815 11.0233Z",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.37976 7.99219H5.60156V12.0062H6.37976V7.99219Z",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.33946 9.5503C7.84868 9.38649 7.72581 9.26353 7.72581 9.05882C7.72581 8.81306 7.97126 8.6083 8.2985 8.6083C8.54395 8.6083 8.74845 8.69026 8.95299 8.93602L9.36215 8.40359C9.03479 8.11676 8.62592 7.95312 8.17592 7.95312C7.48037 7.95312 6.90767 8.44466 6.90767 9.09978C6.90767 9.67333 7.15335 9.91904 7.88952 10.2058C8.21676 10.3284 8.33952 10.3696 8.42148 10.4515C8.58479 10.5333 8.66676 10.6972 8.66676 10.8609C8.66676 11.1886 8.42148 11.4344 8.05311 11.4344C7.68463 11.4344 7.35767 11.2297 7.19402 10.9019L6.70312 11.3935C7.07144 11.9259 7.52138 12.1716 8.09407 12.1716C8.9121 12.1716 9.4845 11.6392 9.4845 10.8609C9.48462 10.1647 9.2394 9.87803 8.33946 9.5503Z",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.0132 10.3268C26.6265 10.2041 26.9539 9.79435 26.9539 9.18013C26.9539 8.443 26.422 7.99219 25.5223 7.99219H24.3359V12.0063H25.1131V10.4087H25.236L26.3401 12.0063H27.2811L26.0132 10.3268ZM25.3585 9.83525H25.1132V8.60663H25.3585C25.8494 8.60663 26.1358 8.81134 26.1358 9.2212C26.1358 9.6306 25.8494 9.83525 25.3585 9.83525Z",
    fill: "#E7E8E3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/discover-icon.4ac30fc569e4e79e98251ffa03830047.svg";
export { ForwardRef as ReactComponent };